import React from 'react';
import './InfoPanel.css';

export default function InfoPanel({ onClose }) {
  return (
    <div className="info-panel-overlay">
      <div className="info-panel">
        <button className="close-button" onClick={onClose}>×</button>
        
        <h2>About Box Breathing</h2>
        
        <div className="info-content">
          <p>
            Box breathing, also known as square breathing, is a powerful technique 
            used by athletes, military personnel, and mindfulness practitioners to:
          </p>
          
          <ul>
            <li>Reduce stress and anxiety</li>
            <li>Improve concentration and focus</li>
            <li>Regulate the autonomic nervous system</li>
            <li>Prepare for sleep or deep meditation</li>
          </ul>
          
          <h3>How It Works</h3>
          
          <p>
            The technique follows a simple pattern with equal duration for each phase:
          </p>
          
          <ol>
            <li><strong>Inhale</strong> slowly and deeply through your nose</li>
            <li><strong>Hold</strong> your breath</li>
            <li><strong>Exhale</strong> completely through your mouth</li>
            <li><strong>Pause</strong> before beginning the next cycle</li>
          </ol>
          
          <p>
            For optimal results, practice box breathing for 5-10 minutes daily. 
            The standard rhythm is 4 seconds per phase, but you can adjust based on your comfort level.
          </p>
          
          <div className="benefits">
            <h3>Benefits</h3>
            <div className="benefits-grid">
              <div className="benefit-item">
                <h4>Stress Reduction</h4>
                <p>Activates the parasympathetic nervous system to calm your body</p>
              </div>
              <div className="benefit-item">
                <h4>Mental Clarity</h4>
                <p>Increases oxygen to your brain for improved cognition</p>
              </div>
              <div className="benefit-item">
                <h4>Emotional Regulation</h4>
                <p>Creates space between stimulus and response</p>
              </div>
              <div className="benefit-item">
                <h4>Better Sleep</h4>
                <p>Helps relax the mind and body before bedtime</p>
              </div>
            </div>
          </div>
        </div>
        
        <button className="primary-button" onClick={onClose}>
          Start Practicing
        </button>
      </div>
    </div>
  );
}